import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "@/lib/api";

/**
 * Short referral link handler. clientquack.com/r/JAMIE-979 → tracks the
 * click and forwards to /register?ref=JAMIE-979 with the code prefilled.
 */
export default function ReferralShortLink() {
  const { code = "" } = useParams();
  const nav = useNavigate();

  useEffect(() => {
    const clean = code.trim().toUpperCase();
    if (!clean) { nav("/", { replace: true }); return; }
    // Persist so registration can pick it up even if the user clicks around.
    try { localStorage.setItem("cq_ref", clean); } catch {}
    // Fire-and-forget click track — don't block the redirect on it.
    api.post("/referrals/track-click", { code: clean, path: "/r" }).catch(() => {});
    // Forward — replace so the browser back button skips the tracker.
    nav(`/register?ref=${clean}`, { replace: true });
  }, [code, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <p className="text-sm text-slate-500">Loading your invite…</p>
    </div>
  );
}
